var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 12,
    viewBox: "0 0 15 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.57963 11.1433C5.45242 11.1425 5.33049 11.0923 5.23963 11.0033L0.109631 6.17329C0.0342697 6.07913 -0.00451717 5.9609 0.000419299 5.84039C0.00535577 5.71989 0.0536829 5.60523 0.136494 5.51755C0.219305 5.42987 0.331018 5.37507 0.451044 5.36326C0.571071 5.35145 0.69132 5.38343 0.789631 5.45329L5.54963 9.92329L14.0696 0.173289C14.113 0.123387 14.1657 0.0825089 14.2248 0.0529893C14.284 0.0234696 14.3483 0.00588633 14.4143 0.0012434C14.4802 -0.00339953 14.5464 0.0049888 14.6091 0.0259295C14.6718 0.0468701 14.7297 0.079953 14.7796 0.123289C14.8295 0.166625 14.8704 0.219366 14.8999 0.278501C14.9295 0.337635 14.947 0.402004 14.9517 0.467934C14.9563 0.533863 14.9479 0.600062 14.927 0.66275C14.9061 0.725438 14.873 0.783387 14.8296 0.833289L5.94963 11.0033C5.85874 11.1023 5.73363 11.163 5.59963 11.1733L5.57963 11.1433Z",
    fill: "#F8F5F3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.8a4f93da5959512523eea56ece79b0d9.svg";
export { ForwardRef as ReactComponent };